<div class="field-dialog__content__scroll disabled-content p-24" fusePerfectScrollbar>
  <div *ngIf="!approval.equipment.customFields || !approval.equipment.customFields.length">
    <div fxLayout="column" fxLayoutAlign="center center">
      <p fxFlex="100" fxLayout="row">
        <mat-icon class="font-size-32">assignment_turned_in</mat-icon>
      </p>
      <div fxFlex="100" fxLayout="row">
        <span class="h3">Nenhum campo customizado</span>
      </div>
    </div>
  </div>

  <form fxLayout="column" *ngIf="approval.equipment.customFields && approval.equipment.customFields.length">
    <div
      fxLayout="row"
      fxLayout.xs="row wrap"
      fxLayoutAlign="start center"
      *ngFor="let customField of approval.equipment.customFields"
    >
      <mat-form-field appearance="legacy" fxFlex="100">
        <mat-label>{{ customField.name }}</mat-label>
        <input matInput *ngIf="customField.type !== 'date'" [value]="customField.value" disabled />
        <input matInput *ngIf="customField.type === 'date'" [value]="customField.value | date: 'dd/MM/yyyy'" disabled />
      </mat-form-field>
    </div>
  </form>
</div>
